import React, { useState } from 'react';
import { DatePicker } from 'antd';
import { ToastError } from 'components/Toaster';
import { ProfileService } from 'core/http/service/Profile.service';
import dayjs from 'dayjs';
import Colors from 'enums/Colors';
import { ButtonHomeV2 } from 'pages/home/components/homeV2/button/ButtonHomeV2.styled';
import { IoReload } from 'react-icons/io5';
import styled from 'styled-components';

const Styled = {
    Container: styled.div`
        display: flex;
        flex-direction: column;
        max-width: 1100px;
        min-height: 320px;
        background-color: #ffffff;
        padding: 40px;
        gap: 2rem;
        margin-bottom: 200px;

        -webkit-box-shadow: 15px 15px 5px -11px rgba(0, 0, 0, 0.27);
        -moz-box-shadow: 15px 15px 5px -11px rgba(0, 0, 0, 0.27);
        box-shadow: 15px 15px 5px -11px rgba(0, 0, 0, 0.27);
    `,

    Header: styled.div`
        display: flex;
        align-items: center;
        justify-content: space-between;
    `,

    Title: styled.h1`
        font-size: 26px;
        font-weight: 700;
        color: ${Colors.Blue};
        text-decoration: underline;
        text-underline-offset: calc(1rem);
    `,

    ClearFilter: styled.div`
        display: flex;
        gap: 0.5rem;
        align-items: center;
        cursor: pointer;
    `,

    Content: styled.div`
        margin-top: 30px;
    `,

    SubTitle: styled.p`
        font-size: 14px;
        font-weight: 600;
        color: ${Colors.Blue};
        margin-bottom: 10px;
    `,
};

const CardReportMarketing = () => {
    const [loadingSubmit, setLoadingSubmit] = useState<boolean>(false);
    const [dataPeriodo, setDataPeriodo] = useState<string[]>([]);

    const profileService = new ProfileService();

    const handleRelatorioMarketing = async () => {
        if (dataPeriodo.length !== 2 || !dataPeriodo[0] || !dataPeriodo[1]) {
            return ToastError('Selecione o período do relatório!');
        }

        setLoadingSubmit(true);

        try {
            const [dateInicio, dateFim] = dataPeriodo;
            const response = await profileService.getRelatorioOrigemCadastro({ dateInicio, dateFim });

            if (response?.status !== 200) {
                throw new Error(`status ${response?.status}`);
            }

            const blob = new Blob([response.data], { type: 'text/csv;charset=UTF-8' });
            const url = window.URL.createObjectURL(blob);

            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `relatorio-marketing-${dateInicio}-a-${dateFim}.csv`);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
        } catch (error) {
            ToastError('Ocorreu algum erro no servidor!');
            console.log('🚀 ~ handleRelatorioMarketing ~ error:', error);
        }

        setLoadingSubmit(false);
    };

    return (
        <Styled.Container>
            <Styled.Header>
                <Styled.Title>RELATÓRIO DE MARKETING</Styled.Title>
                <Styled.ClearFilter onClick={() => setDataPeriodo([])}>
                    <IoReload size={24} />
                    Limpar filtro
                </Styled.ClearFilter>
            </Styled.Header>
            <Styled.Content>
                <Styled.SubTitle>Período de cadastro</Styled.SubTitle>
                <DatePicker.RangePicker
                    size="large"
                    style={{ height: 50 }}
                    format="YYYY-MM-DD"
                    value={dataPeriodo.length === 2 && dataPeriodo[0] ? [dayjs(dataPeriodo[0]), dayjs(dataPeriodo[1])] : null}
                    placeholder={['Início', 'Término']}
                    allowEmpty={[false, false]}
                    onChange={(_, dateString) => setDataPeriodo(dateString)}
                />
            </Styled.Content>
            <ButtonHomeV2
                disabled={loadingSubmit}
                style={{ color: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                onClick={() => {
                    !loadingSubmit && handleRelatorioMarketing();
                }}
            >
                {loadingSubmit ? <div className="loaderCreater" /> : 'Gerar relatório'}
            </ButtonHomeV2>
        </Styled.Container>
    );
};

export default CardReportMarketing;
